import _Typography from "@material-ui/core/esm/Typography";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Form, messages as formMessages } from '@octopy/react-form';
import * as Yup from 'yup';
import { Images } from "../../assets";
import { messages } from "./RegisterMessages";
import { useStyles } from "./RegisterStyles";

const Register = props => {
  const productImage = props.productImage,
        actions = props.actions;
  const intl = useIntl();
  const classes = useStyles();

  const getInitialValues = initialValues => _objectSpread({
    country: '',
    name: '',
    email: '',
    password: '',
    passwordConfirm: '',
    companyName: '',
    personalId: '',
    specialty: '',
    personalDescription: ''
  }, initialValues);

  const getFields = () => [{
    type: 'text',
    name: 'name',
    label: intl.formatMessage(formMessages.nameLabel),
    placeholder: intl.formatMessage(formMessages.namePlaceholder)
  }, {
    type: 'text',
    name: 'email',
    label: intl.formatMessage(formMessages.emailLabel),
    placeholder: intl.formatMessage(formMessages.emailPlaceholder)
  }, {
    type: 'password',
    name: 'password',
    label: intl.formatMessage(formMessages.passwordLabel),
    placeholder: intl.formatMessage(formMessages.passwordPlaceholder)
  }, {
    type: 'password',
    name: 'passwordConfirm',
    label: intl.formatMessage(formMessages.passwordConfirmLabel),
    placeholder: intl.formatMessage(formMessages.passwordConfirmPlaceholder)
  }, {
    type: 'select',
    name: 'country',
    label: intl.formatMessage(formMessages.countryLabel),
    placeholder: intl.formatMessage(formMessages.countryPlaceholder),
    options: [{
      name: 'Argentina',
      code: 'AR'
    }, {
      name: 'Bolivia',
      code: 'BO'
    }, {
      name: 'Ecuador',
      code: 'EC'
    }, {
      name: 'El Salvador',
      code: 'SV'
    }, {
      name: 'Estados Unidos',
      code: 'US'
    }, {
      name: 'Estonia',
      code: 'EE'
    }, {
      name: 'Ethiopia',
      code: 'ET'
    }, {
      name: 'México',
      code: 'MX'
    }, {
      name: 'Micronesia, Federated States of',
      code: 'FM'
    }, {
      name: 'Moldova, Republic of',
      code: 'MD'
    }, {
      name: 'Monaco',
      code: 'MC'
    }],
    getOptionLabel: option => "".concat(option.name || '')
  }, {
    type: 'text',
    name: 'companyName',
    label: intl.formatMessage(formMessages.companyNameLabel),
    placeholder: intl.formatMessage(formMessages.companyNamePlaceholder)
  }, {
    type: 'text',
    name: 'personalId',
    label: intl.formatMessage(formMessages.personalIdLabel),
    placeholder: intl.formatMessage(formMessages.personalIdPlaceholder)
  }, {
    type: 'text',
    name: 'specialty',
    label: intl.formatMessage(formMessages.specialtyLabel),
    placeholder: intl.formatMessage(formMessages.specialtyPlaceholder)
  }, {
    type: 'textarea',
    name: 'personalDescription',
    label: intl.formatMessage(formMessages.personalDescriptionLabel),
    placeholder: intl.formatMessage(formMessages.personalDescriptionPlaceholder)
  }];

  const requiredFieldError = intl.formatMessage(formMessages.requiredFieldError);
  const invalidEmailError = intl.formatMessage(formMessages.invalidEmailError);
  const passwordNoMatchesError = intl.formatMessage(formMessages.passwordNoMatchesError);

  const getValidationRules = () => Yup.object({
    name: Yup.string().required(requiredFieldError),
    email: Yup.string().email(invalidEmailError).required(requiredFieldError),
    password: Yup.string().required(requiredFieldError),
    passwordConfirm: Yup.string().required(requiredFieldError).oneOf([Yup.ref('password')], passwordNoMatchesError),
    country: Yup.string().required(requiredFieldError),
    companyName: Yup.string().required(requiredFieldError),
    personalId: Yup.string().required(requiredFieldError),
    specialty: Yup.string().required(requiredFieldError)
  });

  const handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (formData) {
      if (actions && actions.handleSubmit) actions.handleSubmit(formData);
    });

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return _jsx("div", {
    className: classes.container
  }, void 0, _jsx("div", {
    className: classes.containerForm
  }, void 0, _jsx("img", {
    alt: "product-logo",
    src: productImage || Images.defaultProductLogo,
    className: classes.productLogo
  }), _jsx(_Typography, {
    variant: "body1",
    className: classes.instructions
  }, void 0, intl.formatMessage(messages.formInstructions)), _jsx(Form, {
    initialValues: getInitialValues(),
    validationRules: getValidationRules(),
    fields: getFields(),
    buttonSubmitLabel: intl.formatMessage(messages.buttonSubmit),
    handleSubmit: handleSubmit // error={'Usuario o contraseña invalido'}
    // disableSubmitOnFormInvalid

  }), _jsx(Link, {
    to: '/login',
    className: classes.loginLink
  }, void 0, _jsx(_Typography, {
    variant: "caption"
  }, void 0, intl.formatMessage(messages.haveAccountText), _jsx(_Typography, {
    color: "primary",
    variant: "caption"
  }, void 0, intl.formatMessage(messages.loginText))))));
};

export { Register };